import getUrlHash from './get-url-hash'

export default function (data) {
  const hashObject = getUrlHash()

  for (const item in data) {
    hashObject[item] = data[item]
  }

  let hash = ''

  for (const item in hashObject) {
    if (hashObject[item]) {
      hash += `${item}=${hashObject[item]}&`
    }
  }

  // Remove dangling '&'
  hash = hash.slice(0, -1)

  return '#' + hash
}
